import React, { useEffect, useState } from 'react';
import {FaExclamationCircle, 
        FaQrcode, 
        FaCheck, 
        FaTimes } from "react-icons/fa";
import { API } from 'aws-amplify';
import Moment from 'react-moment';

import Tabs  from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TabContent from 'react-bootstrap/TabContent';
import * as localdb from '../../../../localdb';
import { useI18n } from '../../../../i18n';

import './TaskInfo.css';

const Field = ({ label, children, wide }) => {
    const empty = children === undefined || children === null || children === '';
    return (
        <div className={`info-field${wide ? ' is-wide' : ''}`}>
            <span className="info-label">{label}</span>
            <div className={`info-value${empty ? ' is-empty' : ''}`}>{empty ? '—' : children}</div>
        </div>
    );
};

const hasText = (value) => value !== undefined && value !== null && String(value).trim() !== '';

const TaskInfo = (props) => {
    const { t, tCatalog } = useI18n();
	const [task, setTask] = useState([]);
	const [loadedTask, setLoadedTask] = useState(false);
	const [asset, setAsset] = useState([]);
	const [riAlert, setRIAlert] = useState(false);
    const [users, setUsers] = useState([]);
	const [taskNotes, setTaskNotes] = useState([]);

    const params = { 
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,        
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }

    const getTaskAndAsset = async () => {
        if (!loadedTask) {
            await API.get('task_active','/' + props.taskId, params)
            .then(taskRes => {
                setTask(taskRes)
                setLoadedTask(true)
                if (taskRes.assetId){
                    API.get('assets','/' + taskRes.assetId, params)
                    .then(res => {
                        if (res.hp_site===true) {
                            res.hp_site_str = "High"
                        }else{
                            res.hp_site_str = "Low"
                        }
                        setAsset(res);
                    });
                }
            })
        }
    }

    const getUsers = async () => {
        await API.get('users','/', params)
        .then(res => {
            let userList = []; 
            res.Users.forEach((item) => {
                let user ={}
                user.id = item.Username;
                item.Attributes.forEach((e) => {
                    if (e.Name === 'name')
                        user.name = e.Value;
                }) 
                userList.push(user);                      
            })
            setUsers(userList);
        })
    }

    // Get Asset from props
    useEffect(()=>{
        if (props.asset) {
            setAsset(props.asset);
        }
    }, [props.asset]);

    // Get Task from props
    useEffect(()=>{
        if (props.task) {
            setTask(props.task);
        }
    }, [props.task]);

    useEffect(()=>{
        const loadTaskAndAssets = async () => {
            await getTaskAndAsset();
        }

        if (props.loadedTask !== undefined) {
            setLoadedTask(props.loadedTask)
        } else {
            loadTaskAndAssets();
        }
    }, [props.loadedTask]);

    // Get Users from props
    useEffect(()=>{
        const loadUsers = async () => {
            await getUsers();
        }

        if (props.users) {
            setUsers(props.users);
        } else {
            loadUsers();
        }
    }, [props.users]);

    // Load Task Notes
	useEffect(()=>{
		const fetchNotes = async () => {
			let data = []
			let notes = []
            const boardId = "default";
            const board = await API.get('board','/' + boardId, params);
			
            if (board.data && board.data.lanes){
                data = board.data; 
            }else{
                data = {lanes: []};                          
			} 

			for (let i = 0; i < data.lanes.length; i++) {
				data.lanes[i].cards
					.filter(item => item.taskId !== undefined)
					.forEach(item => {
						notes.push({
							taskId: item.taskId,
							task_ref: item.task,
							note: item.body,
							date: item.dateCreated,
							name: item.name
						});
					})
			}
			setTaskNotes(notes);
		}
		fetchNotes();	
	}, []);

    // Parse task
    useEffect(()=>{
        async function loadTask() {
            if (loadedTask) {
                switch (task.task_status) {
                    case 'Created': 
                        task.cssTaskStatus = "text-warning"; 
                        break;
                    case 'Accepted': 
                        task.cssTaskStatus = "text-danger"; 
                        break;
                    case 'Started': 
                        task.cssTaskStatus = "text-primary"; 
                        break;
                    case 'Completed': 
                        task.cssTaskStatus = "text-success"; 
                        break;
                    case 'WIP': 
                        task.cssTaskStatus = "text-info"; 
                        break;
                    default: 
                        task.cssTaskStatus = "text-dark";
                }

                task.cssAll_detection = "text-secondary mr-3";
                task.cssControllers = "text-secondary mr-3";
                task.cssLamps_fault = "text-secondary mr-3";
                task.cssPush_buttons = "text-secondary mr-3";
                task.cssSignal_head = "text-secondary mr-3";

                if (task.ri) {
                    if (task.ri.q1_lamps && task.ri.q1_lamps.ok) 
                        task.cssLamps_fault = "text-success mr-3"; 
                    else {
                        task.cssLamps_fault = "text-danger mr-3";
                        setRIAlert(true);
                    }
                    if (task.ri.q2_signal_heads && task.ri.q2_signal_heads.ok) 
                        task.cssSignal_head = "text-success mr-3"; 
                    else {
                        task.cssSignal_head = "text-danger mr-3";
                        setRIAlert(true);
                    }
                    if (task.ri.q3_caps_bungs && task.ri.q3_caps_bungs.ok) 
                        task.cssCaps_Bungs = "text-success mr-3"; 
                    else {
                        task.cssCaps_Bungs = "text-danger mr-3";
                        setRIAlert(true);
                    }
                    if (task.ri.q4_push_buttons && task.ri.q4_push_buttons.ok) 
                        task.cssPush_buttons = "text-success mr-3"; 
                    else {
                        task.cssPush_buttons = "text-danger mr-3";
                        setRIAlert(true);
                    }
                    if (task.ri.q5_controller && task.ri.q5_controller.ok) 
                        task.cssControllers = "text-success mr-3"; 
                    else {
                        task.cssControllers = "text-danger mr-3";
                        setRIAlert(true);
                    }
                    if (task.ri.q6_detection && task.ri.q6_detection.ok) 
                        task.cssAll_detection = "text-success mr-3"; 
                    else {
                        task.cssAll_detection = "text-danger mr-3";
                        setRIAlert(true);
                    } 
                    if (task.ri.q7_log_book && task.ri.q7_log_book.ok) 
                        task.cssLogBook = "text-success mr-3"; 
                    else {
                        task.cssLogBook = "text-danger mr-3";
                        setRIAlert(true);
                    }
                    if (task.ri.q8_site_issues && task.ri.q8_site_issues.ok) 
                        task.cssSite_issues = "text-success mr-3"; 
                    else {
                        task.cssSite_issues = "text-danger mr-3";
                        setRIAlert(true);
                    } 
                    if (task.ri.q9_door && task.ri.q9_door.ok) 
                        task.cssDoor = "text-success mr-3"; 
                    else {
                        task.cssDoor = "text-danger mr-3";
                        setRIAlert(true);
                    } 
                }
                
                if (task.date_created){
                    task.date_created_str = <Moment local format='DD-MM-YYYY HH:mm' date={ task.date_created } />
                }
                
                if (task.date_accepted){
                    task.date_accepted_str = <Moment local format='DD-MM-YYYY HH:mm' date={ task.date_accepted } />
                }

                if (task.date_completed){
                    task.date_completed_str = <Moment local format='DD-MM-YYYY HH:mm' date={ task.date_completed } />
                }

                if (task.date_started){
                    task.date_started_str = <Moment local format='DD-MM-YYYY HH:mm' date={ task.date_started } />
                }
                if (task.invoice_date){
                    task.invoice_date_str = <Moment local format='DD-MM-YYYY' date={ task.invoice_date } />
                } else {
                    task.invoice_date_str = '-'
                }

                if (task.date_created && task.date_started){
                    const date_create = new Date(task.date_created); 
                    const date_start = new Date(task.date_started); 
                    const diff = new Date(date_start - date_create);
                    const days = diff.getUTCDate() - 1 
                    let d = 'days'
                    if (days>0){
                        if (days === 1) d ='day'  
                        task.sla_attend_work = days + " " + d + ", "+ ("0"+diff.getUTCHours()).slice(-2) +":"+ ("0"+diff.getUTCMinutes()).slice(-2);
                    } else
                        task.sla_attend_work =  ("0"+diff.getUTCHours()).slice(-2) +":"+ ("0"+diff.getUTCMinutes()).slice(-2);
                }

                if (task.date_completed && task.date_started){
                    const date_complete = new Date(task.date_completed); 
                    const date_start = new Date(task.date_started); 
                    const diff2 = new Date(date_complete - date_start);
                    const days2 = diff2.getUTCDate() - 1 
                    if (days2>0)
                        task.sla_repair_work = days2 + " days, "+ ("0"+diff2.getUTCHours()).slice(-2) +":"+ ("0"+diff2.getUTCMinutes()).slice(-2);
                    else
                        task.sla_repair_work =  ("0"+diff2.getUTCHours()).slice(-2) +":"+ ("0"+diff2.getUTCMinutes()).slice(-2);
                }

                if (task.category){
                    const cat = localdb.CATEGORY.find(i => i.key === task.category)
                    task.category_str = cat.description
                }

                switch (task.chargeable) {
                    case 'true':
                        task.chargeable_str = 'Chargeable'
                    break;
                    case 'false':
                        task.chargeable_str = 'Fixed'
                    break;
                    case 'Chargeable':
                        task.chargeable_str = 'Chargeable'
                    break;
                    case 'Quoted':
                        task.chargeable_str = 'Quoted'
                    break;
                    case 'Fixed':
                        task.chargeable_str = 'Fixed'
                    break;  
                    default:
                        task.chargeable_str = 'Fixed'                 
                }

                if (task.sla_attend){
                    if (task.category==="Reactive"){
                        task.sla_attend_str = task.sla_attend + ' hrs'
                    } else {
                        task.sla_attend_str = task.sla_attend + ' days'
                    }
                }

                if (task.sla_repair){
                    if (task.category==="Reactive"){
                        task.sla_repair_str = task.sla_repair + ' hrs'
                    } else {
                        task.sla_repair_str = task.sla_repair + ' days'
                    }
                }
                setTask(task)
            }
        }
        loadTask();
    }, [loadedTask])

    // Parse Load task for task Notes
    useEffect(()=>{
        if (loadedTask && taskNotes.length > 0) {
            let notes = taskNotes.filter(item => item.taskId ===  task.taskId);
            setTask({...task, notes: notes})
        }
    }, [taskNotes, loadedTask])

    // Parse Load task for users
    useEffect(()=>{
        if (loadedTask && users.length > 0) {
            let user_completed_str = '', user_created_str = '';
            if (task.user_completed){
                const usr_comp = users.find(i => i.id === task.user_completed)
                if (usr_comp) user_completed_str = usr_comp.name
            }
            if (task.user_created){
                const usr_comp = users.find(i => i.id === task.user_created)
                if (usr_comp) user_created_str = usr_comp.name
            }
            setTask({...task, user_completed_str, user_created_str})
        }
    }, [users, loadedTask])

    const materialLines = Array.isArray(task.materials_items) ? task.materials_items : [];
    const materialLinesWithTotals = materialLines.map((item) => {
        const quantity = Number(item.quantity || 0);
        const price = Number(item.price || 0);
        const total = item.total !== undefined && item.total !== null ? Number(item.total) : +(parseFloat(quantity * price)).toFixed(2);
        return {
            itemId: item.itemId || '-',
            description: item.description || '-',
            quantity,
            price,
            total,
        };
    });
    const materialsTotal = materialLinesWithTotals.length > 0
        ? +(parseFloat(materialLinesWithTotals.reduce((sum, i) => sum + Number(i.total || 0), 0))).toFixed(2)
        : Number(task.materials || 0);

const showInvoice = hasText(task.invoice_number) || Boolean(task.invoice_date);
    const showMaterials = materialLinesWithTotals.length > 0 || hasText(task.materials_description);

return ( 
    <div className="TaskInfo">
        <div>
            <div className="task-info-kicker">{t('fields.taskInformation')}</div>
            <Tabs defaultActiveKey="details" transition={false} id="tab_task_det">
            <Tab eventKey="details" title={t('actions.details')}>
                <TabContent>
                <section className="info-section">
                    <h4>{t('fields.siteDetails')}</h4>
                    <div className="info-grid">
                        <Field label={t('fields.siteReference')}>
                            {asset.assetId ? (
                                <button type="button" className="info-link" onClick={() => props.history.push('/asset_det/' + asset.assetId)}>
                                    {asset.site_ref}
                                </button>
                            ) : asset.site_ref}
                        </Field>
                        <Field label={t('common.district')}>{asset.district}</Field>
                        <Field label={t('fields.siteAddress')}>{asset.site_address}</Field>
                    </div>
                </section>
                <section className="info-section">
                    <h4>{t('fields.contractorDetails')}</h4>
                    <div className="info-grid">
                        <Field label={t('common.contractor')}>{task.contractor}</Field>
                        <Field label={t('common.user')}>{task.user_completed_str}</Field>
                        <Field label={t('common.created')}>{task.user_created_str}</Field>
                        <Field label={t('common.created')}>{task.date_created_str}</Field>
                        <Field label={t('status.accepted')}>{task.date_accepted_str}</Field>
                        <Field label={t('status.started')}>
                            {task.date_started_str}
                            <span className={`qr-flag${task.qr_scan_start === true ? ' is-ok' : ''}`} title="QR scan on start">
                                <FaQrcode /> {task.qr_scan_start === true ? <FaCheck /> : <FaTimes />}
                            </span>
                        </Field>
                        <Field label={t('common.completed')}>
                            {task.date_completed_str}
                            <span className={`qr-flag${task.qr_scan_end === true ? ' is-ok' : ''}`} title="QR scan on complete">
                                <FaQrcode /> {task.qr_scan_end === true ? <FaCheck /> : <FaTimes />}
                            </span>
                        </Field>
                        <Field label={t('fields.chargeable')}>{tCatalog(task.chargeable_str)}</Field>
                    </div>
                </section>
                <section className="info-section">
                    <h4>{t('fields.workRequired')}</h4>
                    <div className="info-grid">
                        <Field label={t('common.category')}>{tCatalog(task.category_str)}</Field>
                        <Field label={t('fields.subCategory')}>{tCatalog(task.type_fault)}</Field>
                        <Field label={t('fields.contractorRef')}>{task.contractor_ref}</Field>
                        <Field label={t('fields.jobNumber')}>{task.job_number}</Field>
                        <Field label={t('common.description')} wide>{task.fault_description}</Field>
                        <Field label={t('fields.workRequired')} wide>{task.work_completed}</Field>
                    </div>
                </section>
                {showInvoice && (
                    <section className="info-section">
                        <h4>{t('taskView.invoice')}</h4>
                        <div className="info-grid">
                            <Field label={t('fields.invoiceDate')}>{task.invoice_date_str}</Field>
                            <Field label={t('fields.invoiceNumber')}>{task.invoice_number}</Field>
                        </div>
                    </section>
                )}
                {showMaterials && (
                    <section className="info-section">
                        <h4>{t('fields.materials')}</h4>
                        {materialLinesWithTotals.length > 0 ? (
                            <div className="info-table">
                                {materialLinesWithTotals.map((item, idx) => (
                                    <div key={item.itemId + '_' + idx} className="info-table-row">
                                        <strong>{item.itemId}</strong>
                                        <span>{item.description}</span>
                                        <span>{t('fields.qty')} {item.quantity}</span>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <Field label={t('fields.materials')} wide>{task.materials_description}</Field>
                        )}
                    </section>
                )}
                </TabContent>
            </Tab>
            <Tab eventKey="costs" title={t('nav.costs')}>
                <TabContent>
                <section className="info-section">
                    <h4>{t('fields.materials')}</h4>
                    <div className="info-grid">
                        <Field label={t('fields.materialsTotal')}>€ {Number(materialsTotal || 0).toFixed(2)}</Field>
                    </div>
                    {materialLinesWithTotals.length > 0 && (
                        <div className="info-table">
                            <div className="info-table-row is-head">
                                <span>{t('fields.itemId')}</span>
                                <span>{t('common.description')}</span>
                                <span>{t('fields.qty')}</span>
                                <span>{t('fields.rate')}</span>
                                <span>{t('common.total')}</span>
                            </div>
                            {materialLinesWithTotals.map((item, idx) => (
                                <div key={item.itemId + '_cost_' + idx} className="info-table-row">
                                    <span>{item.itemId}</span>
                                    <span>{item.description}</span>
                                    <span>{item.quantity}</span>
                                    <span>€ {Number(item.price || 0).toFixed(2)}</span>
                                    <span>€ {Number(item.total || 0).toFixed(2)}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </section>
                <section className="info-section">
                    <h4>{t('fields.callOutFee')}</h4>
                    <div className="info-grid">
                        <Field label={t('fields.nr')}>{task.callout_nr}</Field>
                        <Field label={t('fields.rate')}>{task.callout_rate}</Field>
                        <Field label={t('fields.subtotal')}>{task.callout_subtotal !== undefined && task.callout_subtotal !== null && task.callout_subtotal !== '' ? `€ ${task.callout_subtotal}` : ''}</Field>
                    </div>
                </section>
                <section className="info-section">
                    <h4>{t('fields.onSiteLabour')}</h4>
                    <div className="info-grid">
                        <Field label={t('fields.nr')}>{task.onsite_nr}</Field>
                        <Field label={t('fields.rate')}>{task.onsite_rate}</Field>
                        <Field label={t('fields.subtotal')}>{task.onsite_subtotal !== undefined && task.onsite_subtotal !== null && task.onsite_subtotal !== '' ? `€ ${task.onsite_subtotal}` : ''}</Field>
                    </div>
                </section>
                <section className="info-section">
                    <h4>{t('common.total')}</h4>
                    <div className="info-total">€ {task.total_cost || '0'}</div>
                </section>
                </TabContent>
            </Tab>          
            <Tab eventKey="inspection" title={(riAlert) ? <span className='text-danger'>{t('fields.routineInspection')} <FaExclamationCircle /></span>: t('fields.routineInspection')} disabled={!task.ri}>
                <TabContent>
                    <section className="info-section">
                    <h4>{t('fields.routineInspection')}</h4>
                        <div className="ri-row">
                            <div><FaCheck className={task.cssLamps_fault} /> {t('ri.lampsFault')}</div>
                            <div>{(task.ri && task.ri.q1_lamps && task.ri.q1_lamps.problem) ? task.ri.q1_lamps.problem : '—'}</div>
                        </div>
                        <div className="ri-row">
                            <div><FaCheck className={task.cssSignal_head} /> {t('ri.signalHeads')}</div>
                            <div>{(task.ri && task.ri.q2_signal_heads && task.ri.q2_signal_heads.problem) ? task.ri.q2_signal_heads.problem : '—'}</div>
                        </div>
                        <div className="ri-row">
                            <div><FaCheck className={task.cssCaps_Bungs} /> {t('ri.poleCaps')}</div>
                            <div>{(task.ri && task.ri.q3_caps_bungs && task.ri.q3_caps_bungs.problem) ? task.ri.q3_caps_bungs.problem : '—'}</div>
                        </div>
                        <div className="ri-row">
                            <div><FaCheck className={task.cssPush_buttons} /> {t('ri.pushButtons')}</div>
                            <div>{(task.ri && task.ri.q4_push_buttons && task.ri.q4_push_buttons.problem) ? task.ri.q4_push_buttons.problem : '—'}</div>
                        </div>
                        <div className="ri-row">
                            <div><FaCheck className={task.cssControllers} /> {t('ri.controllers')}</div>
                            <div>{(task.ri && task.ri.q5_controller && task.ri.q5_controller.problem) ? task.ri.q5_controller.problem : '—'}</div>
                        </div>
                        <div className="ri-row">
                            <div><FaCheck className={task.cssAll_detection} /> {t('ri.detection')}</div>
                            <div>{(task.ri && task.ri.q6_detection && task.ri.q6_detection.problem) ? task.ri.q6_detection.problem : '—'}</div>
                        </div>
                        <div className="ri-row">
                            <div><FaCheck className={task.cssLogBook} /> {t('ri.logBook')}</div>
                            <div>{(task.ri && task.ri.q7_log_book && task.ri.q7_log_book.problem) ? task.ri.q7_log_book.problem : '—'}</div>
                        </div>
                        <div className="ri-row">
                            <div><FaCheck className={task.cssSite_issues} /> {t('ri.siteIssues')}</div>
                            <div>{(task.ri && task.ri.q8_site_issues && task.ri.q8_site_issues.problem) ? task.ri.q8_site_issues.problem : '—'}</div>
                        </div>
                        <div className="ri-row">
                            <div><FaCheck className={task.cssDoor} /> {t('ri.doorClosed')}</div>
                            <div>{(task.ri && task.ri.q9_door && task.ri.q9_door.problem) ? task.ri.q9_door.problem : '—'}</div>
                        </div>
                    </section>
                </TabContent>
            </Tab>
            </Tabs>     
        </div>
    </div>
    );   
}
 
export default TaskInfo;

